module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/trophy-brigade-lvl2-50.a037ad72.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/trophy-brigade-lvl2-50.png
// module id = 3583
// module chunks = 11